import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { IController } from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PlaceListShortModel } from '../../../core';
import { NfcRetailerStickersService } from '../../nfc-retailer-stickers.service';

class WizardLocationsStep implements IController {
    public static $inject = ['$scope', '$translate', '$uibModal', 'nfcRetailerStickersService', 'notificationService' ];
    public selectedLocations: PlaceListShortModel[];
    public listHeader: string;
    public listEmptyMessage: string;
    public isAllLocationsSelected: boolean;

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        public nfcRetailerStickersService: NfcRetailerStickersService,
        public notificationService: NotificationService
    ) {
    }

    public $onInit(): void {
        this.listHeader = this.$translate.instant('nfc_wizard_locations_step_list_header');
        this.listEmptyMessage = this.$translate.instant('nfc_wizard_locations_step_not_selected');
    }

    public addLocations = async () => {
        let operationResult: any;
        try {
            operationResult = await this.$uibModal.open({
                component: 'selectLocations',
                resolve: {
                    options: () => {
                        return {
                            selectedLocations: this.selectedLocations,
                            isAllSelected: this.isAllLocationsSelected
                        };
                    }
                },
                size: 'md',
                backdrop: 'static',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult && operationResult.status === 'ok') {
            if (operationResult.isAllSelected) {
                this.isAllLocationsSelected = true;
                this.nfcRetailerStickersService.getAllLocations()
                    .then((locations) => {
                        return this.selectedLocations = locations;
                    })
                    .catch((error) => this.notificationService.showErrorMessage(error));
            } else {
                this.isAllLocationsSelected = false;
                this.selectedLocations = operationResult.selectedLocations;
            }
        }
    }

    public deleteLocation = (item: any) => {
        this.selectedLocations = this.selectedLocations.filter((x) => x.ID !== item.ID);
        this.isAllLocationsSelected = false;
    }

}

angular.module('naut').component('wizardLocationsStep', {
    template: require('./wizard-locations-step.component.html'),
    controller: WizardLocationsStep,
    controllerAs: 'ctrl',
    bindings: {
        selectedLocations: '=',
        isAllLocationsSelected: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/nfc-stickers/wizard/wizard-locations-step/wizard-locations-step.component.ts